import React, { lazy } from "react";
import {
    Navigate,
} from "react-router-dom";


const StorageFileComponent = lazy(() => import("../../../../../components/storage-file/components/show/page"));

export const storageFileRoutes = [
    {
        path: 'show',
        element: <StorageFileComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/options/files/show" />
    },
];